import Modal from "components/layout/modal";
import { ListEntityField } from "models/list-entity-field";
import { FunctionComponent } from "react";
import { FormValues } from "lib/form";
import { adminDoPatchListEntityField } from "services/admin/list-entity-field";
import EntityFieldForm from "./entity-field-form";
import { List } from "models/list";

interface EditEntityFieldModalProps {
  list: List;
  entityUuid: string;
  field: ListEntityField;
  existingIdentifiers: string[];
  onChange: () => Promise<void>;
  onClose: () => Promise<void>;
}

const EditEntityFieldModal: FunctionComponent<EditEntityFieldModalProps> = ({
  list,
  entityUuid,
  field,
  existingIdentifiers,
  onChange,
  onClose,
}) => {
  const handleSubmit = async (values: FormValues) => {
    // tallenna muutokset palvelimelle
    await adminDoPatchListEntityField(
      list,
      entityUuid,
      field.uuid,

      // send values, but keep index
      { ...values },
    );

    // signal changes to parent
    await onChange();

    // finally, close the modal
    onClose();
  };

  return (
    <Modal title="Muokkaa kenttää">
      <EntityFieldForm
        field={field}
        onSubmit={handleSubmit}
        existingIdentifiers={existingIdentifiers}
        onClose={onClose}
      />
    </Modal>
  );
};

export default EditEntityFieldModal;
